export default __webpack_public_path__ + "static/media/s3.edf8c424.jpg";